import { CircularProgress } from "@mui/material";
import { Backdrop } from "./styles";

export interface ILoadingBackdropProps {
  loading: boolean;
}

export const LoadingBackdrop = ({ loading }: ILoadingBackdropProps) => {
  if (loading) {
    return (
      <Backdrop>
        <CircularProgress color="primary" />
      </Backdrop>
    );
  } else {
    return null;
  }
};
